import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import React from "react";
import { TalkAgent } from "components/talk-agent/TalkAgent";

const CoverageLimitExceededCard = () => {
    // ========== Render ==========
    return (
        <CardTemplate title="Coverage Limit Exceeded" className="text-base-content">
            <div className="font-medium text-base-content text-base flex flex-col gap-5">
                <p className="leading-6 text-base text-base-content font-medium" id="coverage-limit-exceeded">
                    Our records indicate that you already own a AAA Life Guaranteed Issue Whole Life policy and the amount of
                    this coverage exceeds the $25,000 max limit for this product.
                </p>

                <p className="leading-5 text-sm text-base-content font-medium pr-4">
                    Therefore, we are unable to provide you with another Guaranteed Issue Whole Life Policy online.
                    <br />
                    <span className="font-bold">You account was not charged for the new policy you requested.</span>
                </p>

                <TalkAgent titleClassName="text-black/90" />

                <HoursOperation
                    className="text-black/90"
                    firstLine="Monday-Thursday 9 AM - 10 PM ET,"
                    secondLine="Friday - 9 AM - 8 PM,"
                    thirdLine="Saturday 11 am - 3 pm  ET"
                />
            </div>
        </CardTemplate>
    );
};

export default CoverageLimitExceededCard;
